export default class ScrollDown {
  constructor() {
    this._ScrollDown = document.querySelector('#scroll-down');

    if (this._ScrollDown) {
      this.init();
    }
  }

  init() {
    this._ScrollDown.addEventListener('click', (e) => {
      e.preventDefault();

      let sections = document.querySelectorAll('section');
      const target = sections[1];

      if (target) {
        window.scrollTo({
          top: target.offsetTop,
          behavior: 'smooth',
        });
      }


    });
  }
}
